import { useEffect, useId, useRef } from "react";

const JQUERY_SRC = "https://code.jquery.com/jquery-3.6.0.min.js";
const WIDGET_SRC = "https://widgets.api-sports.io/football.js";

let scriptsPromise: Promise<void> | null = null;

function loadScript(src: string) {
  const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
  if (existing) {
    if ((existing as HTMLScriptElement & { dataset: { loaded?: string } }).dataset.loaded === "true") return Promise.resolve();
    return new Promise<void>((resolve, reject) => {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error(`تعذر تحميل ${src}`)), { once: true });
    });
  }

  return new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.addEventListener("load", () => {
      script.dataset.loaded = "true";
      resolve();
    }, { once: true });
    script.addEventListener("error", () => reject(new Error(`تعذر تحميل ${src}`)), { once: true });
    document.body.appendChild(script);
  });
}

function loadWidgetScripts() {
  if (!scriptsPromise) {
    scriptsPromise = loadScript(JQUERY_SRC)
      .then(() => loadScript(WIDGET_SRC))
      .catch((error) => {
        scriptsPromise = null;
        throw error;
      });
  }
  return scriptsPromise;
}

export default function ApiSportsLiveWidget() {
  const rawId = useId();
  const containerId = `api-sports-live-${rawId.replace(/:/g, "")}`;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;

    loadWidgetScripts()
      .then(() => {
        if (cancelled || !containerRef.current) return;
        const jquery = (window as Window & { jQuery?: (selector: string) => { widgetLiveScore?: (options: Record<string, unknown>) => void } }).jQuery;
        const target = jquery?.(`#${containerId}`);

        if (!target?.widgetLiveScore) {
          throw new Error("تعذر تهيئة ويدجت النتائج المباشرة");
        }

        target.widgetLiveScore({
          widgetWidth: "100%",
          displayCalendar: true,
          justLiveScore: false,
        });
      })
      .catch(() => {
        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = "<p class=\"text-sm text-slate-400\">تعذر تحميل النتائج المباشرة حالياً. جرّب تحديث الصفحة.</p>";
        }
      });

    return () => {
      cancelled = true;
      if (containerRef.current) containerRef.current.innerHTML = "";
    };
  }, [containerId]);

  return (
    <section className="card my-6 overflow-hidden p-4" aria-labelledby={`${containerId}-title`}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="eyebrow">من API-Sports</div>
          <h2 id={`${containerId}-title`} className="mt-1 text-xl font-extrabold text-white">النتائج المباشرة والجدول</h2>
        </div>
        <span className="rounded-lg border border-emerald-200/20 bg-emerald-200/10 px-3 py-1 text-xs text-emerald-100">تحديث مباشر</span>
      </div>
      <div id={containerId} ref={containerRef} className="api-sports-live-widget min-h-24 overflow-x-auto rounded-xl bg-white p-2 text-slate-900" />
    </section>
  );
}
